import { environment } from 'src/environments/environment';

import { HttpClient } from '@angular/common/http';

export abstract class BaseService {
    protected baseUrl: string;
    constructor(protected http: HttpClient, actionUrl: string) {
        this.baseUrl = environment.apiBaseUrl + actionUrl;
    }
}
